import { render, staticRenderFns } from "./TourCategory.vue?vue&type=template&id=2d6dc040&scoped=true&"
import script from "./TourCategory.vue?vue&type=script&lang=js&"
export * from "./TourCategory.vue?vue&type=script&lang=js&"
import style0 from "./TourCategory.vue?vue&type=style&index=0&id=2d6dc040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6dc040",
  null
  
)

export default component.exports